/* Only the actual product-media loop on the Peppermint template.
   Keep its poster until the slide is visible AND initial page load is complete. */
(function () {
  var img = document.querySelector('#witsGallery2 [data-wits-product-loop]');
  if (!img || img.dataset.loopInitialized) return;
  img.dataset.loopInitialized = 'true';
  var poster = img.getAttribute('src'), source = img.dataset.witsProductLoop;
  var visible = false, ready = false, pending = false, scheduled = false;
  var loaded = document.readyState === 'complete';
  function showIfVisible() {
    if (visible && !document.hidden && ready) img.src = source;
  }
  function requestLoop() {
    scheduled = false;
    if (!loaded || !visible || document.hidden || pending || ready) return;
    pending = true;
    var pre = new Image();
    pre.decoding = 'async';
    pre.fetchPriority = 'low';
    pre.onload = function () {
      var decoded = pre.decode ? pre.decode().catch(function () {}) : Promise.resolve();
      decoded.then(function () { pending = false; ready = true; showIfVisible(); });
    };
    pre.onerror = function () { pending = false; };
    pre.src = source;
  }
  function update() {
    if (!visible || document.hidden) { img.src = poster; return; }
    if (ready) { showIfVisible(); return; }
    if (!loaded || scheduled || pending) return;
    scheduled = true;
    if ('requestIdleCallback' in window) window.requestIdleCallback(requestLoop, {timeout: 1500});
    else window.setTimeout(requestLoop, 100);
  }
  if (!loaded) window.addEventListener('load', function () { loaded = true; update(); }, {once: true});
  document.addEventListener('visibilitychange', update);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.35;
      update();
    }, {threshold: [0, 0.35]}).observe(img);
  } else {
    // Older browsers: load only when this thumbnail is explicitly chosen.
    var g = document.getElementById('witsGallery2');
    g.parentNode.querySelector('.thumbs').addEventListener('click', function () {
      window.setTimeout(function () {
        var a = img.getBoundingClientRect(), b = g.getBoundingClientRect();
        visible = a.left < b.right && a.right > b.left;
        update();
      }, 500);
    });
  }
})();

/* Animate the small thumbnail only after load + a quiet interval.
   Its 200px rendition avoids downloading the full slide just for the strip. */
(function () {
  var main = document.querySelector('#witsGallery2 [data-wits-product-loop]');
  var gallery = main && main.closest('.pp2-gallery');
  var thumb = gallery && gallery.querySelector('.thumbs img[src*="wits-loop-pour-5-thumb.webp"]');
  if (!thumb || thumb.dataset.loopThumbInitialized) return;
  thumb.dataset.loopThumbInitialized = 'true';
  var poster = thumb.getAttribute('src');
  var url = new URL(main.dataset.witsProductLoop, window.location.href);
  url.searchParams.set('width', '200');
  var source = url.href;
  var eligible = false, visible = false, ready = false, pending = false, scheduled = false;
  function update() {
    if (!visible || document.hidden) { thumb.src = poster; return; }
    if (ready) { thumb.src = source; return; }
    if (!eligible || pending || scheduled) return;
    scheduled = true;
    function begin() {
      scheduled = false;
      if (!visible || document.hidden || pending || ready) return;
      pending = true;
      var pre = new Image();
      pre.decoding = 'async';
      pre.fetchPriority = 'low';
      pre.onload = function () {
        var decoded = pre.decode ? pre.decode().catch(function () {}) : Promise.resolve();
        decoded.then(function () { pending = false; ready = true; update(); });
      };
      pre.onerror = function () { pending = false; };
      pre.src = source;
    }
    if ('requestIdleCallback' in window) window.requestIdleCallback(begin);
    else window.setTimeout(begin, 200);
  }
  function afterLoad() {
    window.setTimeout(function () { eligible = true; update(); }, 1200);
  }
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, {once: true});
  document.addEventListener('visibilitychange', update);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
      update();
    }, {threshold: [0, 0.1]}).observe(thumb);
  } else { visible = true; }
})();
